// @greenlight-spec: 19-design-system.md
// The muted em-dash placeholder for an empty cell value, shared across data
// tables so "no value" reads consistently.
export function Dash() {
  return <span className="text-muted-foreground">—</span>;
}
